module.exports = __webpack_public_path__ + "43498606750ee3dfa866661d40039a10.pdf";